import { post } from "api/helper";
import { ProcessedApiResponse } from "api/interfaces";
import { Entity } from "interfaces/entities";
import { LoginResponse, VerifyOtpCodeResponse } from "./interfaces";

export const login = (
  email: string,
  password: string,
  recaptchaToken: string
): Promise<ProcessedApiResponse<LoginResponse>> => {
  return post<LoginResponse>("v1/users/login", {
    username: email,
    password,
    recaptchaToken,
  });
};

export const recoverPassword = (
  email: string,
  recaptchaToken: string
): Promise<ProcessedApiResponse> => {
  return post("v1/users/recoverPassword", {
    email,
    recaptchaToken,
  });
};

export const resetPassword = (
  email: string,
  hash: string,
  password: string
): Promise<ProcessedApiResponse> => {
  return post("v1/users/resetPassword", {
    email,
    hash,
    password,
  });
};

export const entityLogin = (
  entityToken: string,
  authToken: string
): Promise<ProcessedApiResponse<Entity>> => {
  return post<Entity>(`v1/entities/${entityToken}/users/login`, {
    token: authToken,
  });
};

export const verifyOtpCode = (
  authToken: string,
  code: number
): Promise<ProcessedApiResponse<VerifyOtpCodeResponse>> => {
  return post("v1/users/verifyOtpCode", {
    token: authToken,
    code,
  });
};

export const resendOtpCode = (
  authToken: string
): Promise<ProcessedApiResponse> => {
  return post("v1/users/resendOtpCode", {
    token: authToken,
  });
};
